import React from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import ActionLinkedCapitalActionsContent from './ActionLinkedCapitalActionsContent';
import { useParams } from 'react-router-dom';

const EqualiseActionLinkedCapitalActions: React.FC<{
  baseCurrency: CurrencyCode;
}> = ({ baseCurrency }) => {
  const { selectedVehicleId } = useLayoutContext();
  const { id } = useParams<{ id?: string }>();

  const [capitalActions] =
    api.equalisations.getCapitalCallSimulation.useSuspenseQuery({
      equalisationId: id ?? '',
      vehicleId: selectedVehicleId ?? '',
    });

  return (
    <ActionLinkedCapitalActionsContent
      capitalActions={capitalActions}
      baseCurrency={baseCurrency}
    />
  );
};

export default EqualiseActionLinkedCapitalActions;
